var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-row',[_c('b-col'),_c('b-col',{attrs:{"sm":"10"}},[_c('div',{attrs:{"id":"nav"}},[_c('h1',[_vm._v("Rollin'")])]),_c('div',{staticClass:"view-container"},[_c('router-view')],1)]),_c('b-col')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }